import { DOCUMENTS_ACTIONS } from '../../actions/documents';

/* 
    documents looks like:
    [
        { type: 'course', items: [ .. the actual docs ]},
        { type: 'lesson', items: [ .. the actual docs ]},
    ]

*/
const initialState = { documents: [], currentDocument: undefined };

const DocumentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'USER_LOGOUT' || 'INVALID_USER':
      return initialState;
    case DOCUMENTS_ACTIONS.DOCUMENT_CLEARED: {
      // remove the current document from state
      return {
        documents: state.documents
      };
    }
    case DOCUMENTS_ACTIONS.DOCUMENTS_LOADED:
      const newDocs = state.documents.filter(
        d => d.type !== action.payload.type
      );
      const newDocList = action.payload;

      if (
        action.payload.route &&
        action.payload.route.collection &&
        action.payload.route.url.indexOf(':') === -1
      ) {
        // if we are loading documents from a top level root, then clear the current document
        delete newDocList.route;
        newDocs.push(newDocList);
        return {
          documents: newDocs
        };
      } else {
        newDocs.push(newDocList);
        return {
          ...state,
          documents: newDocs
        };
      }
    case DOCUMENTS_ACTIONS.DOCUMENTS_FILTERED: {
      return {
        ...state,
        filtered: action.payload
      };
    }
    case DOCUMENTS_ACTIONS.DOCUMENT_LOADED: {
      return {
        ...state,
        currentDocument: action.payload
      };
    }
    default:
      return state;
  }
};

export default DocumentsReducer;
